import type { SVGComponent } from "@tastyworks/icons"
import { Info, Notice } from "@tastyworks/icons"
import { cva, type VariantProps } from "class-variance-authority"
import Actions from "./AlertActions.svelte"
import Description from "./AlertDescription.svelte"
import Icon from "./AlertIcon.svelte"
import Root from "./AlertRoot.svelte"
import Title from "./AlertTitle.svelte"

// Toast notifications only. For inline notices use Banner.
export const Alert = {
  Description,
  Title,
  Root,
  Icon,
  Actions,
}

const variant = {
  primary: "bg-accent-blue-03 text-icon-general-blue", // i.e. processing, partial fill, fill, processed, done
  warning: "bg-accent-gold-03 text-icon-general-gold", // i.e pending,  notice, action required
  error: "bg-accent-red-03 text-icon-general-red",
  information: "bg-general-surface-02 text-icon-general-secondary",
}

export const alertVariantKeys = Object.keys(variant) as (keyof typeof variant)[]

export const alertVariants = cva(
  "box-border w-[440px] rounded-lg border border-solid border-semantic-interaction p-3 shadow-bottom-100 max-sm:w-full",
  {
    variants: { variant },
    defaultVariants: {
      variant: "primary",
    },
  }
)

export const alertIconVariants = cva(
  "h-9 w-9 shrink-0 rounded-full p-2 text-general-secondary-label",
  {
    variants: {
      variant: {
        primary: "bg-accent-blue-alpha-02 text-icon-general-blue",
        error: "bg-accent-red-alpha-02 text-icon-general-error",
        information: "text-icon-general-info bg-general-surface-alpha-01",
        warning: "bg-accent-gold-alpha-02 text-icon-general-pending",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  }
)

export function renderIconByVariant(
  variant: VariantProps<typeof alertVariants>["variant"]
): SVGComponent | undefined {
  switch (variant) {
    case "error":
    case "warning":
      return Notice
    case "primary":
    case "information":
      return Info
  }
}
